(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["freja-engineering"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('freja-details')) {
  customElements.define('freja-details', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[data-tab]')];
      const panels = [...this.querySelectorAll('[data-panel]')];
      const list = this.querySelector('[data-tabs]');
      if (!list || tabs.length !== panels.length) return;
      const select = index => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
      };
      list.hidden = false; list.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab'); panels[index].setAttribute('role', 'tabpanel'); panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); select(next); tabs[next].focus();
        });
      });
      select(0);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freja-retail-access"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('freja-retail-access')) {
  customElements.define('freja-retail-access', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const country = this.querySelector('[data-country]');
      const registration = this.querySelector('[data-registration]');
      const label = this.querySelector('[data-registration-label]');
      if (!country || !registration || !label) return;
      const updateRegistration = () => {
        const french = country.value === 'France';
        label.textContent = french ? label.dataset.french : label.dataset.international;
        registration.inputMode = french ? 'numeric' : 'text';
        if (french) registration.setAttribute('pattern', '(?:[0-9] *){14}');
        else registration.removeAttribute('pattern');
      };
      country.addEventListener('change', updateRegistration);
      updateRegistration();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
